<div class="modal-container-content">
  <div>{{ product?.specs?.description }}</div>
  @if (product?.specs.main_product_id === 151) {
    <a href="{{ this.config.livetv_url }}" class="link-text-only" target="_black">{{ this.config.livetv_url }}</a>
    <app-divider/>
    @if (product.specs.username) {
      <ul>
        <li>
          <span class="label">Abonnementsnummer:</span>
          <span class="value">{{ product.specs.username }}</span>
          <span class="icon"></span>
        </li>
        <li>
          <span class="label">Wachtwoord:</span>
          <span class="value">
            {{ this.isPasswordVisible ? product.specs.password : '********' }}
          </span>
          <span class="icon">
            <app-icon
              [icon]="this.isPasswordVisible ? 'eye-slash' : 'eye'"
              (click)="this.togglePassword()"
              tabindex="0"
              (keydown.enter)="this.togglePassword()"
            ></app-icon>
          </span>
        </li>
      </ul>
    }
    @if (!product.specs.username) {
      <div>
        <span>
          Je hebt nog geen inloggegevens omdat de TV App mogelijk nog niet actief is. Deze worden automatisch aangevraagd zodra je account geactiveerd is.
        </span>
      </div>
    }
  }
</div>
